import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-350e8f80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "header-text" }, "前日確認です", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "予定通り勤務できますか？", -1))
const _hoisted_5 = { class: "balloon" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "ml-1 mr-4 strong-text" }
const _hoisted_8 = { class: "ml-1 strong-text" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"cancel-warning\" data-v-350e8f80><div class=\"cancel-warning-header\" data-v-350e8f80><span class=\"warning-icon\" data-v-350e8f80>!</span>当日キャンセルはご遠慮ください\n        </div> <div data-v-350e8f80>当日キャンセルをした場合、</div> <ol class=\"cancel-warning-list\" data-v-350e8f80><li data-v-350e8f80>\n            現場が混乱し、<span class=\"cancel-warning-bold\" data-v-350e8f80>負担増</span>\n            につながります\n          </li> <li data-v-350e8f80>\n            信用スコアが下がり、一時的に\n            <span class=\"cancel-warning-bold\" data-v-350e8f80>利用停止</span>\n            になる可能性があります\n          </li> <li data-v-350e8f80>\n            直前キャンセルが多い方は、事業所から\n            <span class=\"cancel-warning-bold\" data-v-350e8f80>応募後にお断りされる</span>\n            場合があります\n          </li></ol></div>", 1)
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("\n          少しでも体調に不安があれば、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n          前日までにご調整をよろしくお願いします\n        ")
], -1))

import AppButton from "@/components/atoms/button/AppButton.vue";
import { PropType, computed } from "vue";
import { User } from "@/types/user/User";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { Application } from "@/types/order/Application";
import { orderService } from "@/app/services/OrderService";
import { applicationService } from "@/app/services/ApplicationService";
import { authStore } from "@/store/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'Precautions',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true
  },
  applicationToRemind: {
    type: Object as PropType<Application>,
    required: true
  }
},
  emits: ["cancel", "apply"],
  setup(__props, { emit }) {

const props = __props;




const mainVisualImage = computed(() =>
  require("@/assets/img/applicationReminder/MainVisual" +
    authStore.productAssetSuffix +
    ".png")
);

const getFormattedDate = (application: Application): string => {
  return orderService.getFormattedDateWithSlash(application.order);
};

const getFormattedWorkTimeRange = (application: Application): string => {
  return applicationService.getFormattedWorkTimeRange(application);
};

const onCancel = () => {
  emit("cancel");
};

const onApply = () => {
  emit("apply");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: mainVisualImage.value,
      alt: "明日の勤務でのご活躍を応援しています",
      class: "main-visual"
    }, null, 8, _hoisted_2),
    _createTextVNode(),
    _createElementVNode("div", null, [
      _hoisted_3,
      _createTextVNode(),
      _hoisted_4,
      _createTextVNode(),
      _createElementVNode("p", null, _toDisplayString(__props.user.lastName) + "さんを頼りにしている方がいます", 1)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, [
        _createVNode(FeatherIcon, {
          icon: "calendar",
          size: "20",
          class: "date-icon"
        }),
        _createElementVNode("span", _hoisted_7, _toDisplayString(getFormattedDate(__props.applicationToRemind)), 1),
        _createTextVNode(),
        _createVNode(FeatherIcon, {
          icon: "clock",
          size: "20",
          class: "date-icon"
        }),
        _createElementVNode("span", _hoisted_8, _toDisplayString(getFormattedWorkTimeRange(__props.applicationToRemind)), 1)
      ]),
      _createTextVNode(),
      _createElementVNode("p", null, _toDisplayString(__props.applicationToRemind.order.office.name), 1)
    ]),
    _createTextVNode(),
    _createVNode(AppButton, {
      class: "mt-2 mb-3 text-size-20",
      onClick: onApply
    }, {
      default: _withCtx(() => [
        _createTextVNode("\n      予定通り勤務できる\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", { class: "cancel-container" }, [
      _hoisted_9,
      _createTextVNode(),
      _createElementVNode("div", { class: "cancel-guide" }, [
        _hoisted_10,
        _createTextVNode(),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn-link cancel-text",
            onClick: onCancel
          }, "\n            前日キャンセルはこちら\n          ")
        ])
      ])
    ])
  ]))
}
}

})